import { DataSourcesProvider, useDataSourcesContext } from 'automation-ui-formula-editor/data-sources/DataSourcesContext';
import { useAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { AUTOMATION_EXTENSION } from 'automation-ui-action-features/constants/ActionTypes';
import { getObjectTypeId, getActionHeaderTitle } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { wireFlowById } from 'automation-ui-canvas/queries/flowQueries';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * This provider can be called in three ways.
 * 1. FlowContainer which supports the primary workflow application.
 * 2. In an embed situation the flowConfigsContainer can call for a provider
 * 3. In an embed situation the flowCanvasContainer can call for a provider.
 *
 * Since FlowCanvasContainer and FlowActionConfig are children of FlowContainer this component conditionally instantiates
 * a provider for downline consumption. This is done so that we don't have the same provider embedded within its self
 * that could cause odd behaviors.
 */
const DataSourcesProviderWrapper = ({
  flowId,
  children,
  sourceAppId = SourceApps.WORKFLOWS_APP,
  // from wireFlowById
  flow
}) => {
  var _flow$enrolledType, _allExtensionDefiniti, _allExtensionDefiniti2;
  const isDataSourcesContextInstantiated = useDataSourcesContext();
  const flowObjectTypeId = getObjectTypeId(flow);
  const actionTypeIdsToInclude = flow ? [...new Set(flow.actions.toArray().filter(action => action.actionType === AUTOMATION_EXTENSION).map(action => action.actionTypeId))] : [];
  const allExtensionDefinitionsQuery = useAllExtensionDefinitions({
    objectType: flowObjectTypeId,
    createdSourceApp: sourceAppId,
    actionTypeIdsToInclude,
    enrolledType: flow === null || flow === void 0 || (_flow$enrolledType = flow.enrolledType) === null || _flow$enrolledType === void 0 ? void 0 : _flow$enrolledType.type
  });
  const extensionDefinitions = (_allExtensionDefiniti = (_allExtensionDefiniti2 = allExtensionDefinitionsQuery.data) === null || _allExtensionDefiniti2 === void 0 ? void 0 : _allExtensionDefiniti2.allExtensionDefinitions) !== null && _allExtensionDefiniti !== void 0 ? _allExtensionDefiniti : {};

  // if we already have a dataSourcesContext/Provider don't make a call for another one
  if (isDataSourcesContextInstantiated) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const handleGetActionHeaderTitle = getActionHeaderTitle({
    flow: flow,
    extensionDefinitions,
    isUngated: () => true
  });
  return /*#__PURE__*/_jsx(DataSourcesProvider, {
    flowId: flowId,
    flowObjectTypeId: flowObjectTypeId,
    getActionHeaderTitle: handleGetActionHeaderTitle,
    children: children
  });
};
export default wireFlowById(DataSourcesProviderWrapper);